<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<div class="employeeTrainingPlan">
  <div class="flex card-container">
    <div class="label-wrapper">
      <label>User</label>
    </div>
    <div class="flex flex-row scope-wrapper">
    <div class="tree-wrapper">
      <p-treeSelect
        selectionMode="single"
        [(ngModel)]="selectedUser"
        [options]="treeData"
        [style]="{ 'width': '100%' }"
        [ngClass]="{
          'orange': userWithPendingStatusSelected,
          'green': userWithReviewUpToDateSelected,
          'red': userWithTerminatedStatusSelected
        }"
        (onNodeSelect)="handleTreeSelectChange($event)"
        [filter]="true"
    ></p-treeSelect>
    </div>
    
    <div class="button-container">
      <div class="add-trainingPlan-button">
      <p-button styleClass="p-button-outlined" id="trainingPlanReviewForUser"
      icon="fa fa-eye" iconPos="left" pTooltip="Training Plan Review" tooltipPosition="left"
      (onClick)="reviewUserTrainingPlanReview()" [disabled]="!userWithPendingStatusSelected"
      >
      </p-button>
    </div>    
    
    <div class="add-trainingPlan-button">
    <p-button appPreventDoubleClick styleClass="p-button-outlined" id="addTrainingPlanForUser"
      icon="fa fa-plus" iconPos="left" pTooltip="Add Training Requirement" tooltipPosition="left"
      (debounceClick)="getTrainingPlanSlider()" [disabled]="!enableAddTrainingPlanReviewBtn"
      ></p-button>
    </div>

    <div class="trainingPlanReview-button">
      <p-button styleClass="p-button-outlined" id="trainingPlanReviewHistory"
      icon="pi pi-history" iconPos="left" pTooltip="Training Plan Review History" tooltipPosition="left"
      (onClick)="getTrainingPlanReviewHistory()" [disabled]="!enableTrainingPlanReviewHistoryBtn"
      >
      </p-button>
    </div>

    <div class="trainingPlanReviewExport-button">
      <p-button styleClass="p-button-outlined" id="outstandingReviewsReport"
      icon="fa-solid fa-circle-exclamation" iconPos="left" pTooltip="Outstanding Reviews Report" tooltipPosition="left"
      (onClick)="exportToExcel()"
      ></p-button>
    </div>

    </div>
</div>

<app-employee-training-plan-slider
  *ngIf="isTrainingPlanSliderOpen"
  [isTrainingPlanSliderOpen]="isTrainingPlanSliderOpen"
  (isTrainingPlanSliderActive)="closeTrainingPlanSlider($event)"
  [userScopes]="userScopes"
  [userPUID]="userPUID"
  >
</app-employee-training-plan-slider>

<!-- // employee training Review Plan component -->
<app-user-training-plan-review-history 
  *ngIf="isTrainingPlanReviewHistoryModalOpen"
  [userPuid]="selectedPuid"
  (closeSlider)="closeTrainingPlanReviewHistoryModal($event)">
</app-user-training-plan-review-history>

<app-employees-training-plan-requirements
        [selectedPuid]="selectedPuid"
        [isUserTerminated]="userWithTerminatedStatusSelected">
</app-employees-training-plan-requirements>

<!-- // employee training Review Plan Review -->
<app-user-training-plan-review *ngIf="isReviewButtonEnable"
        [selectedPuid]="selectedPuid" (isModelOpen)="closeReasonDailog($event)">         >
</app-user-training-plan-review>

</div>
